// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './FormFieldCheckbox';



// WEBPACK FOOTER //
// ./components/FormFieldCheckbox/index.js